import user from "./user";

export default {
  namespaced: true,
  modules: {
    user: user,
  },
};
